export const ColorByEnum = {
  Presence: "Presence",
  SolveRate: "SolveRate",
  QuestionSolveRate: "QuestionSolveRate",
  Sentiment: "Sentiment",
  Urgency: "Urgency",
  Fulfillment: "Fulfillment",
} as const
